import PropTypes from 'prop-types';

import summaryShape from 'Workspace/types/cohorts/cohortSummary';
import settingsShape from 'Workspace/types/cohorts/cohortSettings';
import cohortEnrollmentShape from 'Workspace/types/cohorts/cohortEnrollment';
import { collaboratorShape } from 'Workspace/types/collaborator';

const cohortShape = PropTypes.shape({
  summary: summaryShape,
  settings: settingsShape,
  accounts: PropTypes.arrayOf(collaboratorShape),
  enrollments: PropTypes.arrayOf(cohortEnrollmentShape),
});

export default cohortShape;
